<template>
  <div class="app-main-content" type="primary">
    <div
      class="grid-view"
    >
      <div class="main-content">
        <search-item
          ref="searchItem"
          config-module="2400"
          :reset="true"
          :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
          @click-more="value=>isAdvancedQuery=value"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
          @advSearchItemResetCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <el-button
              v-show="$checkPermission(['button_MblManagement_Register'])"
              type="primary"
              @click="registerHandler"
            >{{ this.$t('CargoMsg.Cargo_Register') }}
            </el-button>
            <el-button
              v-show="$checkPermission(['button_MblManagement_Invalid'])"
              type="primary"
              @click="cancellationHandler"
            >{{ this.$t('CargoMsg.Cargo_Invalid') }}
            </el-button>
            <el-button
              v-show="$checkPermission(['button_MblManagement_OrderDelete'])"
              type="danger"
              @click="deleteHandler"
            >{{ this.$t('CargoMsg.Cargo_OrderDelete') }}
            </el-button>
            <!--    设置余量提醒-->
            <el-button
              v-show="$checkPermission(['button_MblManagement_SetAMarginAlert'])"
              type="primary"
              @click="marginReminderHandler"
            >{{ this.$t('CargoMsg.Cargo_SetAMarginAlert') }}
            </el-button>
            <!-- 分配-->
            <el-button
              v-show="$checkPermission(['button_MblManagement_Assignment'])"
              type="primary"
              @click="distributeHandler"
            >{{ this.$t('CargoMsg.Cargo_Assignment') }}
            </el-button>
            <!-- 导入-->
            <el-button
              type="primary"
              @click="importHandler"
            >{{ this.$t('CargoMsg.Cargo_Import') }}
            </el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="24000522"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="24000521"
            :total="filter.total"
            :page-count="pageCount"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery"
          />
        </div>
      </div>
    </div>

    <!--    登记-->
    <register-window
      v-if="registerWindow.visible"
      :visible="registerWindow.visible"
      @close="registerWindow.visible=false"
      @queryList="toQuery"
    />
    <!--    分配-->
    <distribution-window
      v-if="distributionWindow.visible"
      :visible="distributionWindow.visible"
      :mbl-list="distributionWindow.mblList"
      @close="distributionWindow.visible=false"
      @queryList="toQuery"
    />
    <!--    设置提醒-->
    <set-reminder-window
      v-if="setReminderWindow.visible"
      :visible="setReminderWindow.visible"
      @close="setReminderWindow.visible=false"
      @queryList="toQuery"
    />
    <!--    导入-->
    <import-window
      v-if="importWindow.visible"
      :visible="importWindow.visible"
      @close="importWindow.visible=false"
      @queryList="toQuery"
    />

    <!-- 业务编号变更日志 -->
    <el-dialog
      :title="$t('CargoMsg.Cargo_BusinessNoChangeLogRecord')"
      :visible.sync="businessChangeDialog.visible"
      width="600px"
      @close="businessChangeDialog.visible = false"
    >
      <el-table :data="businessChangeDialog.records">
        <el-table-column
          prop="businessNo"
          :label="$t('CargoMsg.Cargo_BusinessNo')"
          width="180"
        />
        <el-table-column
          prop="createdBy"
          :label="$t('CargoMsg.Cargo_OperateBy')"
          width="180"
          :formatter="(row) => loadName(row.createdBy)"
        />
        <el-table-column
          prop="dateCreated"
          :label="$t('CargoMsg.Cargo_OperateTime')"
          :formatter="(row) => loadDateTime(row.dateCreated)"
        />
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
const { advancedQueryFunc } = require('@/api/booking/mblManagement')
import RegisterWindow from '@/views/cargo/v0/SeaExport/MblManagement/components/RegisterWindow'
import DistributionWindow from '@/views/cargo/v0/SeaExport/MblManagement/components/DistributionWindow'
import SetReminderWindow from '@/views/cargo/v0/SeaExport/MblManagement/components/SetReminderWindow'
import { getStateByCode } from '@/class/cargo/model/parameters/CommonState'
import { cancellationFunc, deleteFunc } from '@/api/booking/mblManagement'
import ImportWindow from '@/views/cargo/v0/SeaExport/MblManagement/components/ImportWindow.vue'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'MblManagement',
  components: {
    searchItem,
    RegisterWindow,
    DistributionWindow,
    SetReminderWindow,
    ImportWindow
  },
  data() {
    return {
      URL,
      isAdvancedQuery: false, // 是否为高级查询
      pageCount: 0,
      SystemConstants: SystemConstants,
      filter: {
        conditions: [],
        total: 0,
        pageNum: 1,
        pageSize: 50
      },
      registerWindow: {
        visible: false
      },
      distributionWindow: {
        visible: false,
        mblList: []
      },
      setReminderWindow: {
        visible: false
      },
      importWindow: {
        visible: false
      },
      businessChangeDialog: {
        visible: false,
        records: []
      },
      editMblNoMode: false,
      templateName: null,
      filterJson: {},
      selectData: null,
      fullscreenLoading: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        // 选中
        onRowClicked: (event) => {
          this.selectData = event.data
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          if (this.gridOptions.api && event.column) {
            this.gridOptions.api.forEachNode(node => {
              if (node.rowIndex === event.rowIndex) {
                this.selectData = node.data
              }
            })
          }
        }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_MblNo'),
          colId: 'mblNo',
          field: 'mblNo',
          width: 150,
          cellStyle: params => {
            const hasMultipleRecords = params.data.businessChangeRecordVOS?.length > 1
            return hasMultipleRecords && this.editMblNoMode ? { color: '#409EFF', cursor: 'pointer' } : {}
          },
          onCellClicked: params => {
            const records = params.data.businessChangeRecordVOS
            if (records?.length > 1 && this.editMblNoMode) {
              this.businessChangeDialog.records = records.sort((a, b) => {
                return new Date(b.dateCreated) - new Date(a.dateCreated)
              })
              this.businessChangeDialog.visible = true
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Status'),
          colId: 'state',
          field: 'state',
          width: 150,
          cellRenderer: (params) => {
            const s = getStateByCode(SystemConstants.MBL_STATE_TYPE_LIST, params.value)
            if (s) {
              return this.$store.getters.language === 'zh' ? s.chineseName : s.englishName
            } else {
              return ''
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Acquirer'),
          colId: 'userId',
          field: 'userId',
          width: 150,
          cellRenderer: params => {
            if (params.value) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            } else {
              return '-'
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CarrierShip'),
          colId: 'carrierId',
          field: 'carrierId',
          width: 150,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ApplicableBranch'),
          colId: 'branchId',
          field: 'branchId',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.ApplicableDepartment'),
          colId: 'department',
          field: 'department',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RegisteredDate'),
          colId: 'claimDate',
          field: 'claimDate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AdditionalRemark'),
          colId: 'remark',
          field: 'remark',
          width: 150
        },
        {
          headerName: this.$t('SeaExport.OrderChannels'),
          colId: 'channel',
          field: 'channel',
          width: 150
        }
      ],
      rowData: []
    }
  },
  computed: {
    ColumnUtils() {
      return ColumnUtils
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.toQuery()
    }
  },
  async created() {
    await this.initConfig()
  },
  beforeMount() {
    setTimeout(() => {
      this.toQuery()
    }, 0)
  },
  methods: {
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询
    toSimpleQuery(keyword) {
      if (typeof keyword !== 'undefined') {
        this.filter.jobNo = keyword
        this.filter.conditions = []
        this.filter.pageNum = 1
      }
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading4Cxt()
      advancedQueryFunc(this.filter).then((res) => this.handleQueryData(res)).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    handleQueryData(res) {
      this.rowData = res.data.list
      this.pageCount = res.data.pages
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.fullscreenLoading.close()
    },
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filter.conditions = data
        this.filter.pageNum = 1
      }
      this.filterJson.conditions = this.filter.conditions
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading4Cxt()
      advancedQueryFunc(this.filterJson).then((res) =>
        this.handleQueryData(res)
      ).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    registerHandler() {
      this.registerWindow.visible = true
    },
    closePageHandler() {
      this.registerWindow.visible = false
      this.distributionWindow.visible = false
      this.setReminderWindow.visible = false
    },
    // 作废
    cancellationHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectDataFirst'))
        return
      }
      const list = []
      for (const data of rows) {
        if (data.state === SystemConstants.MBL_STATE_1.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_useTip'))
          return
        }
        if (data.state === SystemConstants.MBL_STATE_0.code) {
          list.push(data.uuid)
        }
      }
      if (list.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_VoidedSuccessfully'))
        return
      }
      this.fullscreenLoading = getLoading4Cxt()
      cancellationFunc(list).then((res) => {
        this.$message.success(this.$t('CargoMsg.Cargo_VoidedSuccessfully'))
        this.toQuery()
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    deleteHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectDataFirst'))
        return
      }
      const list = []
      for (const data of rows) {
        if (data.state !== SystemConstants.MBL_STATE_2.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_DeleteTip'))
          return
        }
        list.push(data.uuid)
      }
      this.fullscreenLoading = getLoading4Cxt()
      deleteFunc(list).then((res) => {
        this.$message.success(this.$t('Message.DeleteSuccessfully'))
        this.toQuery()
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    marginReminderHandler() {
      this.setReminderWindow.visible = true
    },
    distributeHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectDataFirst'))
        return
      }
      const list = []
      for (const data of rows) {
        if (data.state === SystemConstants.MBL_STATE_1.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_useTip'))
          return
        }
        if (data.state === SystemConstants.MBL_STATE_2.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_useTip2'))
          return
        }
        list.push(data.uuid)
      }
      this.distributionWindow.mblList = rows.map(data => data.uuid)
      this.distributionWindow.visible = true
    },
    importHandler() {
      this.importWindow.visible = true
    },
    loadName(createdBy) {
      return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', createdBy, 'chineseName')
    },
    loadDateTime(dateCreated) {
      return ColumnUtils.dateTimeLabelFunc(dateCreated)
    },
    async initConfig() {
      await cache.load(cacheName.CONFIG)
      this.editMblNoMode = String(cache.config.get('EditMblNoMode')) === '3'
    }
  }
}
</script>
